export var FileType;
(function (FileType) {
    FileType["Image"] = "image";
    FileType["Video"] = "video";
    FileType["PDF"] = "pdf";
    FileType["File"] = "file";
})(FileType || (FileType = {}));
